import { Box, Button, Stack, Typography } from "@mui/material";
import Step2Inputs from "../../components/Lifestyle/Step2Inputs";

export default function Step2InputPage({ isValidInputs, handleProceed }) {
    return(
        <Stack spacing={5}>
            <Box>
                <Typography variant="h6" gutterBottom>Your Footprint Profile</Typography>
                <Typography variant="body2" gutterBottom>
                    To receive a more personalized carbon footprint estimation, please provide <b>at least a rough estimate</b> for the following:
                </Typography>
            </Box>
            <Step2Inputs />
            <Button className={`pill_btn ${(!isValidInputs) ? 'Mui-disabled' : 'pri_btn'}`} disabled={!isValidInputs} onClick={handleProceed}>proceed</Button>
        </Stack>
    )
}